import React, { useState, useEffect } from "react";

import {
  Card,
  CardBody,
  Table,
  Row,
  Alert,
  Col,
  Modal
} from "reactstrap";
import API, { base } from "api.js";

import { Helmet } from "react-helmet";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import ArrowIcon from "assets/images/images_new/dropdown-icon.svg";
import UpgradeIcon from "assets/images/images_new/sidebar-icons/11.svg";
import Pagination from "components/Paginate/Pagination";
import PredictionTour from "components/WebsiteTour/PredictionTour";
import Spinner from "components/Loader/Spinner";
import EmptyData from "components/EmptyData/EmptyData";
import { NavLink } from "react-router-dom";

const PREV = "PREV";
const NEXT = "NEXT";

const PredictionFiles = () => {
  const [data, setData] = useState([]);
  const [paidMember, setPaidMember] = useState(true);
  const [paginate, setPaginate] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);
  const [popupTitle, setPopupTitle] = useState(null);
  const [loadNext, setLoadNext] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedId, setSelectedId] = useState(null);
  const [pdfData, setPdfData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);

  useEffect(() => {
    API({
      method: 'GET',
      url: 'user-data-get/active_subscription'
    }).then(data => {
      let active_subscription = data.data.user.active_subscription
      setActiveSubscription(active_subscription);
      if (active_subscription.length === 0 || active_subscription[0].package_id === 9) {
        setPaidMember(false);
      } else {
        setPaidMember(true);
      }
    }).catch(() => {
    });
    loadTemplate();
  }, []);

  const loadTemplate = () => {
    setIsLoading(true)
    API({
      method: 'GET',
      url: 'prediction/list?skip=' + data.length
    }).then(response => {
      const pagination = response.data.length < 10 ? paginate : true;
      const loadnext = response.data.length < 10 ? loadNext : true;

      setData(response.data);
      setPaginate(pagination);
      setLoadNext(loadnext);
      setIsLoading(false)
      setShowModal(true);
    }).catch(() => {
      setIsLoading(false)
    });
  }

    const showCurrentYear = () => {
  const d = new Date();
  return ` - ${d.getFullYear()}`;
};

  const rowAction = (paidMember, rowId, file, title) => {
    if (!paidMember) {
      return (
        <NavLink
          to="/admin/plans"
          className="nav-link view-btn upgrade-plan-btn"
        >
          <img
            className="view-btn-icon"
            src={UpgradeIcon}
            alt="Upgrade"
          />Upgrade Plan
        </NavLink>
      );
    }

    return (
      <div className="d-flex gap-2">
        <a
          href="javascript:void(0)"
          className="nav-link view-btn"
          onClick={(e) => {
            handleViewClick(e, file, title, rowId);
          }}
        >
          <span>View</span>
          <img
            className="view-btn-icon"
            src={ArrowIcon}
            alt="View"
          />
        </a>
        <a
          href="javascript:void(0)"
          className="nav-link view-btn"
          onClick={(e) => {
            handleDownloadClick(e, file, title, rowId);
          }}
        >
          <span>Download</span>
          <img
            className="view-btn-icon"
            src={ArrowIcon}
            alt="Download"
          />
        </a>
      </div>
    );
  };

  const handleViewClick = (e, file, title, id) => {
    if (paidMember) {
      e.preventDefault();
      setPdfData([]); // Fix flash
      setPdfLoading(true);
      setIsOpen(true);
      setPdfFile(`${base}${file}`);
      setPopupTitle(title);
      setSelectedId(id);
    }
  };

  const handleDownloadClick = (e, file, title, id) => {
    if (paidMember) {
      e.preventDefault();
      window.open(`${base}${file}`, '_blank');
    }
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  }

  const loadNextPrev = (offset, limit, type) => {
    API({
      method: 'GET',
      url: `prediction/list?skip=${offset}`
    }).then(response => {
      const load_next = (response.data.length < 10) ? false : true;
      const page_number = (type === PREV) ? (page - 1) : (page + 1);

      setData(response.data);
      setLoadNext(load_next);
      setPage(page_number);
    }).catch(() => { });
  }

  const itemSrNumber = (i) => {
    let start_position = (page * 10) - 10;
    let item_number = (start_position + i);

    return item_number;
  }

  useEffect(() => {
    if (selectedId !== null) {
      setPdfLoading(true);
      API({
        method: 'GET',
        url: 'template/' + selectedId
      }).then(data => {
        setPdfData(data.data.data);
      }).catch(() => {
      }).finally(() => {
        setPdfLoading(false);
      });
    }
  }, [selectedId]);

  const fileURL = () => {
    return `${base}${pdfData.pdf}#toolbar=0`;
    // return `${base}/storage/1756700790.pdf#toolbar=0`;
  }

  return (
    <>
      <Helmet>
        <title>Top PTE Training Institute</title>
      </Helmet>

      <div className="content p-0 w-100 template-page">
        <DashboardHeader title={`Prediction Files ${showCurrentYear()}`} />
        <Row className="outer-wrapper">
          <Col xs={12} className="p-0">
          <Card className="border-0 m-0 m-md-4">
              {!paidMember &&
                <Alert color="success">Please upgrade your plan to access secret templates.</Alert>
              }

              <CardBody className="table-wrapper p-0">
                <Table>
                  <thead className="text-primary">
                    <tr>
                      <th className="table-counting d-none d-md-table-cell">#</th>
                      <th>Title</th>
                      <th className="table-action d-none d-md-table-cell">Action</th>
                    </tr>
                  </thead>

                  <tbody>

                    {
                      isLoading ?
                        <tr>
                          <td colSpan={3}>
                            <Spinner />
                          </td>
                        </tr>
                        : data?.length === 0 ? (
                          <tr>
                          <td colSpan={3}>
                            <EmptyData />
                          </td>
                        </tr>
                         
                        ) :
                          data && data.map((val, key) => {
                            return (
                              <tr key={key}>
                                <td className="d-none d-md-table-cell">{itemSrNumber(key + 1)}</td>
                                <td className="width-enables-sm">
                                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-0 justify-content-between w-100">
                                  {/* <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}> */}
                                    <span style={{ minWidth: 0, wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }}>{val.title}</span>
                                    <div className="d-md-none ms-2 flex-shrink-0">
                                      {rowAction(paidMember, val.id, val.pdf, val.title)}
                                    </div>
                                  </div>
                                </td>
                                <td className="d-none d-md-table-cell" id="view-prediction">{rowAction(paidMember, val.id, val.pdf, val.title)}</td>
                              </tr>
                            );
                          })}

                    {/*loadmore &&
                      <button
                        className="outline-btn mt-4"
                        onClick={
                          (e) => {
                            loadTemplate();
                          }
                        }
                      >Load more</button>
                    */}
                  </tbody>
                </Table>
              </CardBody>

              {paginate &&
                <Pagination
                  PREV={PREV}
                  NEXT={NEXT}
                  loadHandler={loadNextPrev}
                  loadNext={loadNext}
                />
              }

            </Card>
          </Col>

        </Row>
          {showModal && <PredictionTour autoStart={true} dataLoaded={showModal}/> }
      </div>

      {isOpen &&
        <Modal
          isOpen={isOpen}
          modalClassName="view-pdf-popup"
        >
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              onClick={toggle}
            ></button>
            <h1 className="modal-title" id="exampleModalLabel">
              {popupTitle}
            </h1>
          </div>
          <div className="modal-body">
            {pdfLoading ? (
              <div className="text-center p-5">
                <Spinner />
              </div>
            ) : pdfData?.pdf && (
              < embed
                src={fileURL()}
                style={{
                  width: "100%",
                  height: "85vh"
                }}
                frameBorder="0"
              />
            )}
          </div>
        </Modal>
      }
    </>
  );
}

export default PredictionFiles;
